import React from 'react'
import clsx from 'clsx'
import {useLocation} from 'react-router-dom'
import {checkIsActive, KTSVG} from '../../../helpers'
import {useLayout} from '../../core'
import 'font-awesome/css/font-awesome.min.css'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { getSidebarRedDotData } from '../../../../app/pages/UserPages/inbox/InboxSlice/InboxSlice'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

type Props = {
  to: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  parent?: string
  newNavigation?: boolean
}
const AsideMenuItemWithSub: React.FC<Props> = ({
  // @ts-ignore
  children,
  to,
  title,
  icon,
  fontIcon,
  hasBullet,
  parent,
  newNavigation
}) => {
  const navigate = useNavigate();
  const { pathname } = useLocation()
  const isActive = checkIsActive(pathname, to, undefined, false, parent)
  const { config } = useLayout()
  const { aside } = config
  const sidebarRedDotData = useSelector(getSidebarRedDotData)

  return (
    <div className={clsx({
      'd-flex': title === 'Dashboard' && newNavigation 
    })}>
      {title === 'Dashboard' && newNavigation && (
        <div className={clsx('d-flex mt-3 gap-2 cursor-pointer')} style={{ marginLeft: '25px' }}>
          <OverlayTrigger
            placement='top'
            overlay={<Tooltip id='button-tooltip'>Inbox</Tooltip>}
          >
            <div className='notification'>
              <span className='menu-icon' onClick={() => navigate('/inbox')}>
                <KTSVG path={'/media/icons/duotune/navigationicon/messages.svg'} className='dashboard svg-icon-2' />
              </span>
              {sidebarRedDotData?.unread > 0 && (
                <span className='inboxBadge'></span>
              )}
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement='top'
            overlay={<Tooltip id='button-tooltip'>Lead Management</Tooltip>}
          >
            <span className='menu-icon' onClick={() => navigate('/contact-collection')}>
              <KTSVG path={'/media/icons/duotune/communication/com005.svg'} className='dashboard svg-icon-2' />
            </span>
          </OverlayTrigger>
        </div>
      )}
      <div
        className={clsx('menu-item', 'menu-accordion', {
          'new-navigation': newNavigation
        })}
        data-kt-menu-trigger='click'
        data-kt-menu-placement="top-start"
      >
        <span className='menu-link'>
          {hasBullet && (
            <span className='menu-bullet'>
              <span className='bullet bullet-dot'></span>
            </span>
          )}
          {icon && aside.menuIcon === 'svg' && (
            <div className='d-flex gap-1'>
              <span className='menu-icon'>
                <KTSVG path={icon} className='svg-icon-2' />
              </span>
            </div>
          )}

          {icon === '' && fontIcon !== '' && (
            <div className='position-relative '>
              <span className='menu-icon'>
                <i className={clsx('bi fs-3', fontIcon)}></i>
              </span>
            </div>
          )}

          {!hasBullet && !icon && !fontIcon && (
            <span className='menu-bullet'>
              <span className=''></span>
            </span>
          )}

          <span className='menu-title' style={{ fontSize: '14px' }}>{title}</span>
          <span className='menu-arrow'></span>
        </span>
        <div className={clsx('menu-sub menu-sub-accordion', {
            'menu-active-bg': isActive,
            'new-dashboard': title === 'Dashboard' && newNavigation
          })}>
          {children}
        </div>
      </div>
    </div>
  )
}

export { AsideMenuItemWithSub }
